import { ModelSagresDatatable } from "@/types/model-sagres-datatable";
import { ParticipanteLicitacao } from "./participante-licitacao";
import { VencedorItem } from "./vencedor-item";

export class LicitacaoVencedorItem extends ModelSagresDatatable {
  NuSequencialItem: number;
  DeItem: string;
  DeUnidadeMedida: string;
  FlFracassado: string; //'S' ou 'N'
  NmParticipante: string;
  DtHomologacaoItem: Date;
  VlTotalLicitado: number;

  //adicionados em 20230706 (copiado de LicitacaoVencedorLote em 20230725)
  IdItemLicitacao: number;
  IdLicitacao: number;
  IdParticipanteLicitacaoNavigation: ParticipanteLicitacao;
  VlTotalEstimado: number;
  QtdItens: number;

  //transient usado para editar participante vencedor
  Vencedores: VencedorItem[];
  Vencedor?: string; // este é atribuído só nos detalhes da licitação

  //TO-DO: Centralizar estes tratamentos no ModelSagres. Dá pra loopar o obj e tratar todas as datas.
  //também dá pra criar enums para estas strings sim/nao, ativo/inativo etc
  tratarDadosDaAPI(): void {
    if (this.DtHomologacaoItem) {
      this.DtHomologacaoItem = new Date(this.DtHomologacaoItem);
    }
    if (this.FlFracassado) {
      this.FlFracassado = ["s", "S", "Sim"].includes(this.FlFracassado)
        ? "Sim"
        : "Não";
    }
    this.Vencedores = this.Vencedores.map((v) => {
      const vencedor = Object.assign(new VencedorItem(), v);
      vencedor.tratarDadosDaAPI();
      return vencedor;
    });
  }
}
